// The trivia question-progress dots: one place to decide a dot's state and the
// values that render it.
//
// Every value is a custom property with the previous hardcoded value as its
// fallback, so a break can recolour the dots from its own custom CSS without
// having to out-specify the inline style, while a break that defines nothing
// renders exactly as before. The fallbacks are not optional: an undefined
// custom property invalidates the whole declaration, which would leave the dot
// with no background at all.

export const getDotState = (question, isCurrentQuestion, wasAnswered) => {
  if (isCurrentQuestion && !wasAnswered) {
    return 'active'
  }
  if (!wasAnswered) {
    return 'pending'
  }
  return question.correct ? 'correct' : 'incorrect'
}

// The icon the shared Difference component renders inside an answered dot.
export const getDotDifferenceType = state => {
  if (state === 'correct') {
    return 'found'
  }
  if (state === 'incorrect') {
    return 'cantFind'
  }
  return null
}

export const getDotBackgroundColor = (state, sponsoredType) => {
  switch (state) {
    case 'active':
      return sponsoredType !== 'sponsored'
        ? 'var(--text-trivia-dot-active-background, var(--theme-color-primary))'
        : 'var(--text-trivia-dot-active-background, #ffffff)'
    case 'correct':
      return 'var(--text-trivia-dot-correct-background, #5bab7f)'
    case 'incorrect':
      return 'var(--text-trivia-dot-incorrect-background, #b11616)'
    default:
      return 'var(--text-trivia-dot-pending-background, #8c8c8c)'
  }
}

// Per state first, then the value for every dot, then what the dot rendered
// before any of this existed. Chained so a break can put a border on the
// active dot without also outlining the answered ones -- those carry a tick or
// a cross, and a border reads as damage on them.
const dotProperty = (state, property, fallback) =>
  `var(--text-trivia-dot-${state}-${property}, var(--text-trivia-dot-${property}, ${fallback}))`

export const getDotBorder = state => dotProperty(state, 'border', 'none')

export const getDotIconColor = state =>
  dotProperty(state, 'icon-color', 'var(--theme-color-white)')

export const getDotStyle = (state, sponsoredType) => ({
  width: 'var(--text-trivia-dot-size, 13px)',
  height: 'var(--text-trivia-dot-size, 13px)',
  backgroundColor: getDotBackgroundColor(state, sponsoredType),
  color: getDotIconColor(state),
  border: getDotBorder(state),
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
})

// Unhashed, so custom CSS has a target that survives a rebuild. The hashed
// module class the Difference component already emits is kept alongside it.
export const getDotClassName = state => `db-trivia-dot db-trivia-dot--${state}`
